import timeElapsedCounter from './time-elapsed'

const KEYCODE_ESC = 27

const IS_TOP = true

const SELECTORS = {
  BTN_START: '#HeaderDesktop__StartButton',
  HEADER_WRAP: '#HeaderDesktopWrap',
  NAV_WRAP: '#NavDesktopWrap',
  NAV_PANE: '.nav-desktop__pane',
  NAV_SUBLIST: '.nav-desktop__sublist',
  NAV_SEARCH_INPUT: '#NavDesktopSearchInput',
  BTN_CART: '#HeaderDesktop__CartBtn',
  CART_WRAP: '#CartDesktopWrap',
  SHORTCUT_NAV_WRAP: '.nav-shortcuts',
  BTN_SHORTCUT_NAV: '.header-desktop__shortcut',
}

const IS_TOP_CLASS = 'header-desktop--is-top'
const IS_BOTTOM_CLASS = 'header-desktop--is-bottom'
const NAV_SUBLIST_ACTIVE_CLASS = 'nav-desktop__sublist--is-active'

const $body = $('body')

const $header = $(SELECTORS.HEADER_WRAP)
const $navWrap = $(SELECTORS.NAV_WRAP)
const $navPanes = $(SELECTORS.NAV_PANE)
const $allSubMenus = $(SELECTORS.NAV_SUBLIST)
const $navSearchInput = $(SELECTORS.NAV_SEARCH_INPUT)
const $cartWrap = $(SELECTORS.CART_WRAP)
const $shortcutNavWrap = $(SELECTORS.SHORTCUT_NAV_WRAP)

const $btnStart = $(SELECTORS.BTN_START)
const $btnCart = $(SELECTORS.BTN_CART)
const $btnShortcutNav = $(SELECTORS.BTN_SHORTCUT_NAV)

const NAV_ACTIVE_CLASS = 'nav-desktop--is-active'
const NAV_ACTIVE_PANE = 'nav-desktop__pane--is-active'
const CART_ACTIVE_CLASS = 'cart-desktop--is-active'
const SHORTCUT_NAV_ACTIVE_CLASS = 'nav-shortcuts--is-active'

const BTN_START_ACTIVE_CLASS = 'header-desktop__btn-menu--is-active'
const BTN_CART_ACTIVE_CLASS = 'header-desktop__btn-cart--is-active'
const BTN_SHORTCUT_NAV_ACTIVE_CLASS = 'header-desktop__shortcut--is-active'

let menuIsOpen = $navWrap.hasClass(NAV_ACTIVE_CLASS) || false
let cartIsOpen = $cartWrap.hasClass(CART_ACTIVE_CLASS) || false

let timeoutId = null

export default () => {

  if (IS_TOP) {
    $body.addClass('has-top-header-desktop')
  } else {
    $body
      .removeClass('has-top-header-desktop')
      .addClass('has-bottom-header-desktop')
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(timeElapsedCounter.start, { timeout: 5000 })
  } else {
    timeElapsedCounter.start()
  }

  $btnStart.on('mouseover', () => openMenu())
  $btnShortcutNav.on('mouseover mouseout', () => {
    clearTimeout(timeoutId)
    if (event.type === 'mouseover') {
      const shortcutHandle = $(event.target).attr('data-toggle-shortcut')
      openShortcutMenu(shortcutHandle)
      return
    }
  })

  $shortcutNavWrap.on('mouseout', (event) => {
    if (!event.relatedTarget) {
      return
    }

    const isShortcut = $(event.target).hasClass('nav-shortcuts__item')

    if (!isShortcut) {
      timeoutId = setTimeout(closeShortcutMenu, 1000)
    }
  })

  $(document).on('click touch keyup resize', (event) => {
    const shortcutHandle = $(event.target).attr('data-toggle-shortcut')

    if (event.type === 'keyup' && event.keyCode == KEYCODE_ESC) {
      if (cartIsOpen) {
        closeCart()
      }

      if (menuIsOpen) {
        closeMenu()
      }

      if (shortcutMenuIsOpen()) {
        closeShortcutMenu()
      }
      return
    }

    const isRelevantToMenu =
      Boolean($(event.target).parents(SELECTORS.NAV_WRAP).length) ||
      Boolean($(event.target).parents(SELECTORS.BTN_START).length) ||
      Boolean($(event.target).siblings(SELECTORS.NAV_PANE).length) ||
      Boolean($(event.target).parents(SELECTORS.NAV_PANE).length)

    const isRelevantToCart =
      Boolean($(event.target).parents(SELECTORS.CART_WRAP).length) ||
      Boolean($(event.target).parents(SELECTORS.BTN_CART).length)

    const isMenuBtn = $(event.target).closest(SELECTORS.BTN_START).is($btnStart)
    const isCartBtn = $(event.target).closest(SELECTORS.BTN_CART).is($btnCart)
    const isShortcutMenuBtn = $(event.target).closest(SELECTORS.BTN_SHORTCUT_NAV).is($btnShortcutNav)

    if (isCartBtn) {
      event.preventDefault()
      toggleCart()
    }

    if (isMenuBtn) {
      toggleMenu()
      return
    }

    if (isShortcutMenuBtn) {
      toggleShortcutMenu(shortcutHandle)
      return
    }

    if (cartIsOpen && !isRelevantToCart) {
      closeCart()
      return
    }

    if (menuIsOpen && !isRelevantToMenu) {
      closeMenu()
      return
    }

    if (shortcutMenuIsOpen()) {
      closeShortcutMenu(shortcutHandle)
      return
    }
  })
}

export function openMenu() {
  $navWrap.addClass(NAV_ACTIVE_CLASS)
  $btnStart.addClass(BTN_START_ACTIVE_CLASS)
  menuIsOpen = true

  if (cartIsOpen) {
    closeCart()
  }

  if (shortcutMenuIsOpen()) {
    closeShortcutMenu()
  }
}

export function closeMenu() {
  $navWrap.removeClass(NAV_ACTIVE_CLASS)
  $navPanes.removeClass(NAV_ACTIVE_PANE)
  $allSubMenus.removeClass(NAV_SUBLIST_ACTIVE_CLASS)
  $btnStart.removeClass(BTN_START_ACTIVE_CLASS)
  $navSearchInput.blur()
  menuIsOpen = false
}

export function toggleMenu() {
  if (menuIsOpen === true) {
    closeMenu()
  } else {
    openMenu()
  }
}

export function openCart() {
  $cartWrap.scrollTop(0)
  $cartWrap.addClass(CART_ACTIVE_CLASS)
  $btnCart.addClass(BTN_CART_ACTIVE_CLASS)
  cartIsOpen = true

  if (shortcutMenuIsOpen()) {
    closeShortcutMenu()
  }
}

export function closeCart() {
  $cartWrap.removeClass(CART_ACTIVE_CLASS)
  $btnCart.removeClass(BTN_CART_ACTIVE_CLASS)
  cartIsOpen = false
}

export function toggleCart() {
  if (cartIsOpen) {
    closeCart()
  } else {
    openCart()
  }
}

export function openShortcutMenu(handle) {
  if (!handle) {
    throw Error('openShortcutMenu requires a handle')
  }

  const $btn = $btnShortcutNav.filter(function() { return $(this).attr('data-toggle-shortcut') === handle })
  const leftOffset = $btn.offset().left
  const $wrap = $shortcutNavWrap.filter(function() { return $(this).attr('data-shortcuts-handle') === handle })

  $wrap.addClass(SHORTCUT_NAV_ACTIVE_CLASS)
    .css('left', `${leftOffset}px`)
    .siblings()
    .removeClass(SHORTCUT_NAV_ACTIVE_CLASS)

  $btn.addClass(BTN_SHORTCUT_NAV_ACTIVE_CLASS)
    .siblings()
    .removeClass(BTN_SHORTCUT_NAV_ACTIVE_CLASS)

  if (cartIsOpen) {
    closeCart()
  }

  if (menuIsOpen) {
    closeMenu()
  }
}

export function closeShortcutMenu(handle) {
  if (typeof handle !== 'string') {
    $shortcutNavWrap.removeClass(SHORTCUT_NAV_ACTIVE_CLASS)
    $btnShortcutNav.removeClass(BTN_SHORTCUT_NAV_ACTIVE_CLASS)
  }

  const $btn = $btnShortcutNav.filter(function() { return $(this).attr('data-toggle-shortcut') === handle })
  const $wrap = $shortcutNavWrap.filter(function() { return $(this).attr('data-shortcuts-handle') === handle })

  $wrap.removeClass(SHORTCUT_NAV_ACTIVE_CLASS)
  $btn.removeClass(BTN_SHORTCUT_NAV_ACTIVE_CLASS)
}

export function toggleShortcutMenu(handle) {
  if (shortcutMenuIsOpen(handle) === true) {
    closeShortcutMenu(handle)
  } else {
    openShortcutMenu(handle)
  }
}

function shortcutMenuIsOpen(handle) {
  if (typeof handle !== 'string') {
    return $shortcutNavWrap.hasClass(SHORTCUT_NAV_ACTIVE_CLASS) || false
  }

  const $wrap = $shortcutNavWrap.filter(function() { return $(this).attr('data-shortcuts-handle') === handle })

  return $wrap.hasClass(SHORTCUT_NAV_ACTIVE_CLASS) || false
}



// WEBPACK FOOTER //
// ./header-desktop.js